import React, { useState } from "react";
import styles from "./users.module.css";
import { RxCross1 } from "react-icons/rx";
import UserDetail from "./UserDetail";
import UserDocuments from "./UserDocuments";
import UserReferral from "./UserReferral";
import UserReview from "./UserReview";

const UsersModal = ({ setToggleUsersDetails,itemData, toggleUsersDetails }) => {
  const [toggleContent, setToggleContent] = useState("Details");
  // console.log("item of card:",itemData);
   const updateUserStatus = async (itemData, status) => {
    // Implement the logic to update user status here
    console.log(`Updating user status to ${status}`);
    console.log(`Updating user`,itemData);
    // You can call an API or update state as needed
  };
  return (
    <>
      <div className={styles.main}>
        <div className={styles.container}>
          <div className={styles.header_div}>
            <span style={{ fontSize: "1.4rem", color: "purple" }}>
              {itemData.first_name} {itemData.last_name}
            </span>
            <RxCross1
              size={"1rem"}
              onClick={() => setToggleUsersDetails(false)}
              cursor={"pointer"}
            />
          </div>
          {/* <hr /> */}
          <div style={{ display: "flex" }}>
            {["Details", "Documents", "Referral", "Review"].map((item) => (
              <hr
                style={{
                  width: "25%",
                  borderTop:
                    item === toggleContent ? "5px solid " : "1px solid",
                  color:
                    item === toggleContent
                      ? "var(--color--2)"
                      : "var(--light-color3)",
                  borderRadius: "10px",
                  borderBottom: "none",
                  borderLeft: "none",
                  borderRight: "none",
                }}
              />
            ))}

            {/* <hr
              style={{
                width: "25%",
                borderTop: "1px solid",
                color: "blue",
                borderRadius: "10px",
              }}
            />
            <hr
              style={{
                width: "25%",
                borderTop: "1px solid",
                color: "green",
                borderRadius: "10px",
              }}
            />
            <hr
              style={{
                width: "25%",
                borderTop: "1px solid",
                color: "red",
                borderRadius: "10px",
              }}
            /> */}
          </div>
          <div className={styles.content_list}>
            {/* <span>Details</span>
            <span>Documents</span>
            <span>Referral</span>
            <span>Review</span> */}
            {["Details", "Documents", "Referral", "Review"].map((item) => (
              <span
                onClick={() => setToggleContent(item)}
                style={{
                  color:
                    item === toggleContent
                      ? "var(--color--2)"
                      : "var(--light-color3)",
                  cursor: "pointer",
                }}
              >
                {item}
              </span>
            ))}
          </div>

          {toggleContent === "Details" && <UserDetail type={"users"} itemData={itemData} onToggleStatus={(status) => {updateUserStatus(itemData, status);}}/>}
          {/* {toggleContent === "Documents" && <UserDocuments />} */}
          {toggleContent === "Referral" && <UserReferral itemData={itemData}/>}
          {toggleContent === "Review" && (
            <UserReview reviews={["Store", "Product","Delivery-Man"]} type={"users"} />
          )}
        </div>
      </div>
    </>
  );
};

export default UsersModal;
